import { createContext } from 'react';

import { ChartUnit } from '../../core/types/chart-unit.js';
import {
  WeakMapSeries,
  WeakMapBins,
  HistogramSeries,
} from '../types/histogram.js';

export interface HistogramFilteredData {
  series: HistogramSeries[];
  seriesMap: WeakMapSeries;
  binsMap: WeakMapBins;
  units: ChartUnit[];
  minMaxPerUnit: Map<ChartUnit, { min: number; max: number }>;
  minMaxXValue: { min: number; max: number };
}

export const HistogramFilteredDataContext =
  createContext<HistogramFilteredData>({
    series: [],
    seriesMap: new WeakMap(),
    binsMap: new WeakMap(),
    units: [],
    minMaxPerUnit: new Map(),
    minMaxXValue: { min: 0, max: 0 },
  });
